var render = function render(){var _vm=this,_c=_vm._self._c;return _c('survey-calculator',{attrs:{"title":"label_violenceSurvey_calculator_title","background-color":"#f5fafd","template-id":"ViolenceSurvey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }